import { useSelector, shallowEqual } from "react-redux";
import PropTypes from "prop-types";
import { getAllSwitchableShops } from "app/reducers/shopSelector";

const mapStateToProps = state => {
	return {
		currentShop: state?.shop,
		shops: getAllSwitchableShops(state),
		currencyCode: state.currency,
	};
};

const ShopSwitcherContainer = ownProps => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	const props = { ...ownProps, ...stateProps };
	return typeof props.renderComponent === "function" && props.renderComponent(props);
};

ShopSwitcherContainer.propTypes = {
	shouldGetAllShops: PropTypes.bool,
};

export default ShopSwitcherContainer;
